import { render, staticRenderFns } from "./WaybillFilters.vue?vue&type=template&id=618c0977&scoped=true"
import script from "./WaybillFilters.vue?vue&type=script&lang=js"
export * from "./WaybillFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c0977",
  null
  
)

export default component.exports